<template>
    <div>   <a-drawer
            :title='title'
            :visible="visible"
            v-bind="drawerConfig"
            :body-style="{ paddingBottom: '80px' }"
            @close="onClose"
    >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                    ref="a_xgw_category_id"
                    label="分类名称"
                    prop="a_xgw_category_id"
                    :help="formErr.a_xgw_category_id"
                    :validateStatus='!formErr.a_xgw_category_id||formErr.a_xgw_category_id==""?"":"error"'
            >
                <a-select v-model="form.a_xgw_category_id">
                <a-select-option :value="item.id" :key="item.id" v-for="item in seleList.category"  >
                    {{item.name}}
                </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item
                    ref="name"
                    label="标题"
                    prop="name"
                    :help="formErr.name"
                    :validateStatus='!formErr.name||formErr.name==""?"":"error"'
            >
                <a-input
                        :maxLength=200
                        v-model="form.name"
                        @change="(e) => { formErr.name=''}"
                        @blur="(e) => {  form.name = e.target.value.trim();}"
                />

            </a-form-model-item>
            <a-form-model-item
                    ref="website"
                    label="网址"
                    prop="website"
                    :help="formErr.website"
                    :validateStatus='!formErr.website||formErr.website==""?"":"error"'
            >
                <a-input
                        v-model="form.website"
                        @change="(e) => { formErr.website=''}"
                        @blur="(e) => {  form.website = e.target.value.trim();}"
                />
            </a-form-model-item>
            <a-form-model-item
                    ref="release_time"
                    label="发布时间"
                    prop="release_time"
                    :help="formErr.release_time"
                    :validateStatus='!formErr.release_time||formErr.release_time==""?"":"error"'
            >
                <a-date-picker  :format="dateFormat" show-time  v-model="form.release_time"/>
            </a-form-model-item>

            <a-form-model-item
                    ref="status"
                    label="状态"
                    prop="status"
                    :extra="formErr.status"
                    :validateStatus='!formErr.status||formErr.status==""?"":"error"'
            >
                <a-radio-group v-model="form.status"  >
                    <a-radio :value="item.value" :key="item.value" v-for="item in this.seleList.status"> {{item.name}} </a-radio>
                </a-radio-group>
            </a-form-model-item>

        </a-form-model>
        <div class="drawer-btn"  >

            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
                确定
            </a-button>
            <a-button @click="onClose">
            取消
        </a-button>
        </div>
    </a-drawer></div>
</template>

<script>
    import {submitForm,drawerConfig,validator} from "../../../../utils/utils"
    import API from "../api";
    import moment from 'moment';
    export default {
        name: "newForm",
        // props: ["visible","title","editId"],
        props: {
            visible:{type: Boolean,},
            title:{type: String,},
            editId:{type: [String, Number],},

        },
        data() {
            return {
                seleList:[],
                drawerConfig ,
                dateFormat: 'YYYY-MM-DD HH:mm:ss',
                form: {
                    a_xgw_category_id:"",
                    name:"",
                    website:"",
                    release_time:moment(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                    status:1,
                },
                formErr: {
                    a_xgw_category_id:"",
                    name:"",
                    website:"",
                    release_time:"",
                    status:"",
                },
                rules: {
                    a_xgw_category_id: [{required: true, message: "请输入分类名称 ",  },{validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.a_xgw_category_id)}  , trigger: "blur"  },],
                    name: [{required: true, message: "请输入标题 ",  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.name)}  , trigger: "blur"  },],
                    website:[{required: true, message: "请输入网址 ",trigger:['change', 'blur']  }, {validator:(rule, value, callback)=>{validator(rule, value, callback,this.formErr.website)}  , trigger:["blur","change"]   },],

                },
                layout: {
                    labelCol: { span:4},
                    wrapperCol: { span:16},
                },
            };
        },
        watch:{
            visible:function(){
                this.form.release_time=moment(new Date(), 'YYYY-MM-DD HH:mm:ss')
            },
            editId: function (a, b) {
                if (a != "") {
                    API.service.EDIT_DATA(a).then(res => {
                        let data=res.data.data.info
                        this.form.release_time=moment(res.data.data.info.release_time, 'YYYY-MM-DD HH:mm:ss')
                        this.form = data
                        this.form.id=a
                    })
                } else {
                    this.form.id = ''

                }
            }
        },
        mounted(){
            this.getFormData()
        },
        methods: {
            getFormData(){
                API.service.ADD_DATA().then(res => {
                    this.seleList={
                        category:res.data.data.category,
                        status:res.data.data.status,
                    }
                })
            },
            onClose() {
                this.$emit("changVisible", false);
                this.formErr={
                    a_xgw_category_id:"",
                    name:"",
                    website:"",
                    release_time:"",
                    status:"",
                }
                this.$refs.ruleForm.resetFields();
            },
            onSubmit() {
                let _this = this;
             //    let subData=JSON.parse(JSON.stringify(this.form))
             // alert(subData.release_time!=""&&subData.release_time!=null)
               this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let url
                        let subData=JSON.parse(JSON.stringify(this.form))
                        subData.release_time!=""&&subData.release_time!=null?subData.release_time=moment(subData.release_time).format('YYYY-MM-DD HH:mm:ss'):subData.release_time=null

                        subData.id == '' || subData.id == undefined ? url = API.service.SUBMIT_ADD : url = API.service.SUBMIT_EDIT
                        submitForm(url, subData).then(res => {
                            if (res == true) {
                                this.onClose()
                            } else {
                                res.map((item, index) => {
                                    this.formErr[item.field] = item.msg
                                })
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
    }
</script>

<style scoped>
.ant-input-number-input{width: 100%!important;}
.ant-input-number{width: 100%!important;}
</style>
